/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ResolveAUniversalClinicExternalSessionIdToItsCanonicalClinicRequestIdClinicRequestResolveGetParams =
  {
    external_session_id: string;
    user_id: string;
  };
